import { SalesOrderStatus } from '@rematter/frontend-lib-api-client';
import { Badge } from '@rematter/ui-web';

const getStatusColor = (status: SalesOrderStatus) => {
  switch (status) {
    case 'Draft':
      return 'warning';
    case 'Finished':
      return 'success';
    case 'Open':
      return 'primary';
    case 'Voided':
      return 'failure';
    default:
      return 'neutral';
  }
};

type PurchaseOrderStatusBadgeProps = {
  status: SalesOrderStatus;
};

export const PurchaseOrderStatusBadge = ({
  status,
}: PurchaseOrderStatusBadgeProps) => (
  <Badge color={getStatusColor(status)} className="@PurchaseOrderStatusBadge">
    {status}
  </Badge>
);
